import { Row } from "reactstrap";
import { formatRP, getUser } from "../../../Utils/externalFunctions";
import { Link } from "react-router-dom";
import { Info } from "react-feather";
import { admins } from "../../../Constant";
import ModalEdit from "../component/ModalEdit";

const RincianAnggaranColumns = (
  setSelectedRencimp,
  toggleModalDetail,
  getRencanaImp,
  selectedAnggaran
) => {
  const columns = [
    {
      name: "PK",
      selector: (row) => row.pk,
      sortable: true,
      wrap: true,
    },
    {
      name: "DPSJ",
      selector: (row) => row.nm_org,
      sortable: true,
      wrap: true,
    },
    {
      name: "Kegiatan",
      selector: (row) => row.kd_keg + "-" + row.nm_keg,
      sortable: true,
      wrap: true,
    },
    {
      name: "Akun",
      selector: (row) => row.kd_akun + "-" + row.nm_akun,
      sortable: true,
      wrap: true,
    },
    {
      name: "Anggaran (Rp)",
      selector: (row) => parseInt(row.anggaran),
      sortable: true,
      format: (row) => formatRP(row.anggaran),
    },
    {
      name: "Sisa (Rp)",
      selector: (row) => parseInt(row.anggaran_tersisa),
      sortable: true,
      format: (row) => formatRP(row.anggaran_tersisa),
    },
    {
      name: "Operasi",
      cell: (row) => (
        <Row className="justify-content-between mt-2">
          <Link
            className="col-auto"
            onClick={(e) => {
              e.preventDefault();
              setSelectedRencimp(row);
              toggleModalDetail();
            }}
          >
            <Info />
          </Link>
        </Row>
      ),
    },
  ];

  if (admins.includes(getUser())) {
    columns.push({
      name: "Edit Sisa Anggaran",
      cell: (row) => (
        <ModalEdit
          selectedRencimp={row}
          getRencanaImp={() => getRencanaImp(selectedAnggaran.pk)}
        />
      ),
      sortable: true,
    });
  }

  return columns;
};

export default RincianAnggaranColumns;
